/**
 * Halton low-discrepancy sequence — used to generate sub-pixel jitter offsets
 * for temporal anti-aliasing. Index 0 maps to 0.0; pass `index + 1` to get a
 * useful sample. Standard pair for 2D jitter is `(halton(i, 2), halton(i, 3))`.
 */
export function halton(index: number, base: number): number {
  let f = 1;
  let r = 0;
  while (index > 0) {
    f /= base;
    r += f * (index % base);
    index = Math.floor(index / base);
  }
  return r;
}
